export default "__VITE_ASSET__Dy61iCaA__"